import React from 'react';
import { generateIcon } from '../generateIcon';

export const IconCheckCircleFilled = generateIcon({
  name: 'CheckCircleFilled',
  path: (
    <path d="M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16ZM22.0607 14.0607C22.6464 13.4749 22.6464 12.5251 22.0607 11.9393C21.4749 11.3536 20.5251 11.3536 19.9393 11.9393L14 17.8787L12.0607 15.9393C11.4749 15.3536 10.5251 15.3536 9.93934 15.9393C9.35355 16.5251 9.35355 17.4749 9.93934 18.0607L12.9393 21.0607C13.5251 21.6464 14.4749 21.6464 15.0607 21.0607L22.0607 14.0607Z" />
  ),
});
